export default function CouchageTab() {
    return (
        <div className="text-center text-gray-400 text-lg py-20">
            🛌 Fonctionnalité "Couchage" non implémentée pour le moment.
        </div>
    );
}